import React from "react";
import ExaminationComponent from "@components/User/Examination/Examination";

export default function Examinations() {
  return <ExaminationComponent />;
}
